const FeaturesData = [
  // FULL TIME + PART TIME LANDING PAGE
  {
    name: 'calendar2',
    text: 'mardi et jeudi soirs',
    subtext: 'et samedi toute la journée',
    page: ['rncp6-partTime-landing'],
  },
  {
    name: 'calendar2',
    text: 'du lundi au vendredi',
    subtext: 'de 9h à 18h',
    page: ['rncp6-fullTime-landing', 'rncp6-alternance-landing'],
  },
  {
    name: 'format',
    text: '100% à distance',
    subtext: 'en visio',
    page: ['rncp6-partTime-landing'],
  },
  {
    name: 'teachersx2',
    text: '1 à 2 formateurs',
    subtext: 'en permanence',
    page: ['rncp6-partTime-landing', 'rncp6-partTime'],
  },
  {
    name: 'teachersx4',
    text: '4 formateurs et mentors',
    subtext: 'en permanence',
    page: [
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'support',
    text: '2 cours de soutien',
    subtext: 'mardi et jeudi de 8h à 9h',
    page: [
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'formation',
    text: '400h de formation',
    subtext: 'théorie et pratique',
    page: ['rncp6-partTime-landing', 'rncp6-fullTime-landing', 'rncp6-fullTime', 'rncp6-partTime'],
  },
  {
    name: 'formation',
    text: '721h de formation',
    subtext: 'théorie et pratique',
    page: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    name: 'diploma',
    text: '1 titre RNCP',
    subtext: 'niveau 6 (Bac+3/4)',
    page: [
      'rncp6-partTime-landing',
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-partTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'calendar',
    text: '1 stage en entreprise',
    subtext: '6 mois (facultatif)',
    page: ['rncp6-partTime-landing', 'rncp6-fullTime-landing', 'rncp6-fullTime', 'rncp6-partTime'],
  },
  {
    name: 'calendar',
    text: '1 CDD/CDI signé',
    subtext: 'intégrez une entreprise',
    page: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    name: 'video',
    text: '100h de vidéos',
    subtext: 'en complément des cours',
    page: [
      'rncp6-partTime-landing',
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-partTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'format',
    text: '2 formats adaptés',
    subtext: 'en présentiel ou à distance',
    page: [
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'platform',
    text: '1 plateforme e-learning',
    subtext: 'avec un accès à vie',
    page: [
      'rncp6-partTime-landing',
      'rncp6-fullTime-landing',
      'rncp6-fullTime',
      'rncp6-partTime',
      'rncp6-alternance',
      'rncp6-alternance-landing',
    ],
  },
  {
    name: 'discount',
    text: '40% de remise',
    subtext: 'sur nos formations pro',
    page: ['rncp6-fullTime', 'rncp6-partTime'],
  },

  // E-LEARNING LANDING PAGE
  {
    name: 'calendar',
    text: 'Une formation reconnue',
    page: ['rncp5-e-learning-landing', 'reunion-landing'],
  },
  {
    name: 'formation',
    text: 'Les technos les plus recherchées',
    page: ['rncp5-e-learning-landing', 'reunion-landing'],
  },
  {
    name: 'diploma',
    text: 'Possibilité de passer un titre RNCP',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'finance',
    text: 'Des dispositifs de financement',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'teachersx4',
    text: '4 formateurs et mentors',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'teachersx4',
    text: '4 formateurs et mentors',
    subtext: 'une heure par semaine',
    page: ['rncp5-e-learning'],
  },
  {
    name: 'support',
    text: '420h de formation',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'formation',
    text: '420h de formation',
    subtext: 'théorie et pratique',
    page: ['rncp5-e-learning'],
  },
  {
    name: 'calendar',
    text: 'Possibilité de poursuivre en alternance',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'calendar',
    text: 'Possibilité de poursuivre en alternance',
    subtext: '15 à 17 mois (facultatif)',
    page: ['rncp5-e-learning'],
  },
  {
    name: 'platform',
    text: '1 plateforme e-learning',
    page: ['rncp5-e-learning-landing'],
  },
  {
    name: 'platform',
    text: '1 plateforme e-learning',
    subtext: 'accessible pendant 6 mois',
    page: ['rncp5-e-learning'],
  },
  {
    name: 'calendar',
    text: '1 stage en entreprise',
    subtext: '2 mois (facultatif)',
    page: ['rncp5-e-learning'],
  },

  // MEETING LANDING PAGE
  {
    name: 'support',
    text: 'De nombreux cas pratiques',
    page: ['reunion-landing'],
  },
  {
    name: 'teachersx2',
    text: 'Un accompagnement individuel',
    page: ['reunion-landing'],
  },
  {
    name: 'diploma',
    text: 'Un titre RNCP',
    page: ['reunion-landing'],
  },
  {
    name: 'platform',
    text: 'Des cours accessibles à vie',
    page: ['reunion-landing'],
  },
  {
    name: 'alumni',
    text: `Un réseau d'alumni`,
    page: ['reunion-landing'],
  },
  {
    name: 'finance',
    text: 'Des financements pour tous',
    page: ['reunion-landing'],
  },
];

export default FeaturesData;
